import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.array.slice";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  query GetMoneyTransferAccountEligibility($financialPortalId: ID!) {\n    moneyTransferAccountEligibility(financialPortalId: $financialPortalId) {\n      accounts {\n        id\n        eligibility\n        financialAccountType\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetMoneyManagementAccounts {\n    moneyTransferAccounts {\n      numAccountsLeftToAdd\n      maxAccountsPerUser\n      accounts {\n        id\n        computedStatus\n        financialAccountId\n        financialAccountType\n        financialAccountLastFour\n        institutionName\n        nameMatchSuccess\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { gql } from '@nerdwallet/apollo';
export var GET_MONEY_MANAGEMENT_ACCOUNTS = gql(_templateObject());
export var GET_MONEY_TRANSFER_ACCOUNT_ELIGIBILITY = gql(_templateObject2());